import api from "../../config/axios";

export const userProfileUpdate = async (userDetails) => {
  const {
    user_id,
    username,
    email,
    mobile,
    skills,
    highest_degree,
    graduation_year,
    college_name,
    branch,
    internship_experience_year,
    internship_experience_month,
    organisation_experience_year,
    organisation_experience_month,
    total_experience_month,
    total_experience_year,
    job_designation,
    current_location,
    preferred_location,
    current_salary,
    expected_salary,
    availability,
  } = userDetails;
  try {
    const response = await api.post(`/update_user_profile`, {
      user_id,
      username,
      email,
      mobile,
      skills,
      highest_degree,
      graduation_year,
      college_name,
      branch,
      internship_experience_year,
      internship_experience_month,
      organisation_experience_year,
      organisation_experience_month,
      total_experience_month,
      total_experience_year,
      job_designation,
      current_location,
      preferred_location,
      current_salary,
      expected_salary,
      availability,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// Lightweight profile update activity logger
export const updateUserProfileActivity = async (userId, message) => {
  try {
    const response = await api.post(`/update_user_profile_date`, {
      user_id: userId,
      profile_updated_message: message,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// Update user insertion datetime (e.g. when user visits profile page)
export const updateUserInsertionDatetime = async (userId) => {
  try {
    const response = await api.post(`/update_user_insertion_datetime`, {
      user_id: userId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getUserInfo = async (userId) => {
  try {
    const response = await api.post(`/user_info`, {
      user_id: userId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const resumeDownload = async (userId, filetype) => {
  try {
    const response = await api.post(
      `/v1/download_resume`,
      {
        user_id: userId,
        filetype,
      },
      {
        responseType: "blob",
      }
    );
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

{/* New Changes in Recommmended Skills Start*/}
export const userSkillRecommendation = async (skills) => {
  try {
    const response = await api.post(`/v1/recommend_skills_resume`, {
      skills: skills,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
{/* New Changes in Recommmended Skills End*/}

export const userPhotoCapture = async (userImage, userId) => {
  try {
    const response = await api.post(
      `/save_face`,
      {
        image_file: userImage,
        user_id: userId,
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const userIdCapture = async (userImage, userId) => {
  try {
    const response = await api.post(
      `/save_id`,
      {
        image_file: userImage,
        user_id: userId,
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const userAudioCapture = async (audioFile, userid) => {
  try {
    const response = await api.post(
      `/v1/audio_verify?useride=${userid}`,
      {
        file: audioFile,
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const doesAudioExist = async (userId) => {
  try {
    const response = await api.get(`/v1/audio_exist?userid=${userId}`);
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const verifyTestToken = async (token, userId, testId) => {
  try {
    const response = await api.post(`/v1/add_test_token`, {
      token: token,
      user_id: userId,
      test_id: testId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// Store tool user for interview/question generator
export const storeToolUser = async (userData) => {
  try {
    const { name, email, mobile } = userData;
    const response = await api.post(`/store_tool_user`, {
      name,
      email,
      mobile,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// Send Aptofy intro email to tool user
export const sendAptofyIntroEmail = async (customerData) => {
  try {
    const { customer_name, customer_email } = customerData;
    const response = await api.post(`/send_aptofy_intro_email`, {
      customer_name,
      customer_email,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

// face id validations
export const doesFaceMatch = async (userId) => {
  try {
    const response = await api.post(`/validate_face_id`, {
      user_id: userId,
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      error.message = typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message || "Face validation failed";
    }
    throw error;
  }
};

// check id details validation
/*export const doesIdMatch = async (userId) => {
  try {
    const response = await api.post(`/check_id_details`, {
      user_id: userId,
    });
    return response.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};*/

export const doesIdMatch = async (userId) => {
  try {
    const response = await api.post(`/check_id_details`, {
      user_id: userId,
    });
    const idMatch = response.data.status;
    // console.log("ID check response", idMatch);
    return idMatch; // Return the ID match status (true or false)
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};

export const getAppliedJobs = async (userId) => {
  try {
    const res = await api.post("/get_apply_job", { user_id: userId });
    return res.data;
  } catch (error) {
    error.message = error.response && error.response.data.message;
    throw error;
  }
};
